import { render } from "./LbrxTableCard.vue?vue&type=template&id=3ef60abf&scoped=true"
import script from "./LbrxTableCard.vue?vue&type=script&lang=js"
export * from "./LbrxTableCard.vue?vue&type=script&lang=js"

import "./LbrxTableCard.vue?vue&type=style&index=0&id=3ef60abf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef60abf"]])

export default __exports__